import { render } from "./IndexPimpinan.vue?vue&type=template&id=787e81d5"
import script from "./IndexPimpinan.vue?vue&type=script&lang=js"
export * from "./IndexPimpinan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__